import styled from 'styled-components';
import { Button } from 'antd';
import { HeartFilled, FilePdfOutlined } from '@ant-design/icons';

export const SuccessContainer = styled.div`
  max-width: 600px;
  margin: 60px auto;
  padding: 60px 40px;
  text-align: center;
  background: linear-gradient(135deg, #f5f9fc 0%, #e8f4f8 100%);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    margin: 20px;
    padding: 40px 20px;
  }
`;

export const IconContainer = styled.div`
  margin-bottom: 32px;
  position: relative;
`;

export const HeartIcon = styled(HeartFilled)`
  font-size: 80px;
  color: #000;
  display: block;
  animation: heartbeat 1.5s infinite;
  
  @keyframes heartbeat {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
`;

export const StyledTitle = styled.h1`
  color: #000 !important;
  margin-bottom: 24px !important;
  font-weight: 600 !important;
  font-size: 28px;
`;

export const ActionButton = styled(Button)`
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 24px;
  padding: 0 32px;
  margin-top: 24px;
  background-color: #4A90E2;
  border-color: #4A90E2;
  color: white;
  box-shadow: none;
  
  &:hover, &:focus {
    background-color: #3a7bc8;
    border-color: #3a7bc8;
    color: white;
    box-shadow: none;
  }
`;

export const DownloadSection = styled.div`
  background: #fff;
  border: 2px solid #4A90E2;
  border-radius: 12px;
  padding: 20px;
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const PdfIcon = styled(FilePdfOutlined)`
  font-size: 48px;
  color: #e74c3c;
`;

export const DownloadButton = styled(Button)`
  height: 44px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 22px;
  padding: 0 28px;
  background-color: #27ae60;
  border-color: #27ae60;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover, &:focus {
    background-color: #219a52;
    border-color: #219a52;
    color: white;
  }
  
  &:disabled {
    background-color: #95a5a6;
    border-color: #95a5a6;
  }
`;

export const EventInfo = styled.div`
  background: rgba(74, 144, 226, 0.1);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  text-align: left;
  
  p {
    margin: 4px 0;
    font-size: 14px;
    
    strong {
      color: #2C3E50;
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  margin-top: 24px;
`;
